import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "monto",
})
export class MontoPipe implements PipeTransform {
    transform(value: string | number, ...args: unknown[]): unknown {
        let valores = [];
        if (typeof value === "string") {
            valores = value.split("$");
        }

        if (
            (valores.length === 2 && valores[1] === "0") ||
            (valores.length === 0 && (value === "0" || value === 0))
        ) {
            return "Pago por parte del empleador";
        } else {
            return value;
        }
    }
}
